<template>
   <div class="h-100">
      <SpinnerOverlay v-show="dataLoading" />
      <div class="position-relative h-100">
         <Sidebar v-if="sidebar !== SidebarStates.HIDDEN" />

         <div class="main-container" :class="{'msg-expanded': !msgCollapsed}">
            <div class="content-container" :class="containerClasses">
               <div class="content">
                  <ClientHeader />
                  <AlertMessages class="layout-alerts" />
                  <transition-group name="fade-fast" mode="out-in">
                     <PageLoad v-if="pageLoading" key="tg-page-load" />
                     <div v-show="!pageLoading" key="tg-page-content">
                        <slot :dataLoading="dataLoading" :pageLoading="pageLoading" />
                     </div>
                  </transition-group>
               </div>
               <Footer class="footer" />
            </div>
            <ClientMessaging />
         </div>
      </div>

      <StudyConfigurationNotice />
   </div>
</template>

<script>
import {mapGetters} from 'vuex';
import {SidebarStates} from '@/store/modules/session';

import AlertMessages from '@/views/common/widgets/AlertMessages';
import ClientHeader from '@/views/common/widgets/ClientHeader';
import Footer from '@/views/common/widgets/Footer';
import SpinnerOverlay from '@/views/common/widgets/SpinnerOverlay';
import Sidebar from '@/views/common/widgets/Sidebar.vue';
import StudyConfigurationNotice from './widgets/StudyConfigurationNotice.vue';
import PageLoad from './widgets/PageLoad.vue';

import ClientMessaging from '@/views/messaging/ClientMessaging';

export default {
   props: {
      dataLoading: Boolean,
      pageLoading: Boolean,
   },

   components: {
      AlertMessages,
      ClientHeader,
      Footer,
      Sidebar,
      SpinnerOverlay,
      ClientMessaging,
      StudyConfigurationNotice,
      PageLoad,
   },

   data() {
      return {
         SidebarStates,
      };
   },

   computed: {
      ...mapGetters({
         sidebar: 'sidebar',
         profile: 'profile',
         stage: 'activeStage',
         msgCollapsed: 'messaging/clientMessagingCollapsed',
      }),
      containerClasses() {
         let backgroundImage;

         switch (this.stage?.id) {
            case 'company':
               backgroundImage = 'employees';
               break;

            case 'contractors':
               backgroundImage = 'employees';
               break;

            case 'dashboard':
               backgroundImage = 'accounting';
               break;

            case 'project':
               backgroundImage = 'research';
               break;

            case 'supplies':
               backgroundImage = 'accounting';
               break;

            case 'time':
               backgroundImage = 'time';
               break;

            case 'uploads':
               backgroundImage = 'docs';
               break;

            case 'cloud':
               backgroundImage = 'cloud';
               break;

            default:
               backgroundImage = null;
         }

         return [
            ...(backgroundImage != null ? ['bg-illustration', `bg-${backgroundImage}`] : []),
            {'no-sidebar': this.sidebar === SidebarStates.HIDDEN},
         ];
      },
   },
};
</script>

<style lang="scss" scoped>
$sidebar-width: 13rem;
$sidebar-width-collapsed: 3.9rem;

.main-container {
   min-height: 100%;
   padding-right: 0;
   transition: padding 0.5s ease;

   &.msg-expanded {
      padding-right: 375px; // Width of <ClientMessaging>

      .content-container {
         background-position: calc(100% - 375px) bottom;
      }
   }
}

.content-container {
   padding-top: 0.5rem;
   margin-left: $sidebar-width;
   min-height: 100vh;
   background-position: right bottom;
   display: flex;
   flex-direction: column;
   background-color: #f4f4f4;

   .content {
      flex: 1 0 auto;
      padding-bottom: 2rem;
   }

   .footer {
      flex-shrink: 0;
   }

   &.no-sidebar {
      margin-left: 0;

      .container {
         padding: 1.25rem 3rem 2rem 2rem;
      }
   }

   &.bg-illustration {
      background-attachment: fixed;
      background-repeat: no-repeat;
      background-position: right bottom;
      background-size: 50%;
      transition: background-position 0.5s ease;

      &.bg-docs {
         background-image: url('../../assets/img/background/docs.png');
      }

      &.bg-employees {
         background-image: url('../../assets/img/background/employees.png');
      }

      &.bg-research {
         background-image: url('../../assets/img/background/research.png');
      }

      &.bg-time {
         background-image: url('../../assets/img/background/time.png');
      }

      &.bg-cloud {
         background-image: url('../../assets/img/background/cloud.png');
      }
   }
}

@media (max-width: 959px) {
   .content-container {
      margin-left: $sidebar-width-collapsed !important;
   }
}

.layout-alerts {
   position: fixed;
   left: 50%;
   top: 60px;
   transform: translateX(-50%);
   z-index: 100;
}
</style>
